import { render, staticRenderFns } from "./CartaoProposta.vue?vue&type=template&id=d67911f2"
import script from "./CartaoProposta.vue?vue&type=script&lang=js"
export * from "./CartaoProposta.vue?vue&type=script&lang=js"
import style0 from "./CartaoProposta.vue?vue&type=style&index=0&id=d67911f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports